module.exports = __webpack_public_path__ + "img/kong.42ef98ba.png";